import { Alert, PageHeader } from "@station/ui";
import { createFileRoute } from "@tanstack/react-router";
import type { ReactElement } from "react";
import { useTranslation } from "react-i18next";
import { SubscriptionBody } from "../../../features/platform/account.js";
import { useDocumentTitle } from "../../../lib/hooks.js";
import { usePermissions } from "../../../lib/session.js";

export const Route = createFileRoute("/_app/ayarlar/abonelik")({ component: SubscriptionPage });

/**
 * Abonelik ve faturalar (Prompt 24): plan, dönem, kullanım, platform faturaları, fatura profili ve tüm verinin dışa aktarımı.
 * Hesap ödeme nedeniyle salt okunurken de açıktır (profil düzenlenir, veri dışa aktarılır — veri hiçbir aşamada silinmez).
 */
function SubscriptionPage(): ReactElement {
  const { t } = useTranslation();
  const allowed = usePermissions().has("tenant.billing.read");
  useDocumentTitle(t("menu.subscription"));
  return (
    <>
      <PageHeader
        title={t("menu.subscription")}
        description={t("account.subscription.description")}
        breadcrumb={[{ label: t("menu.groups.settings") }, { label: t("menu.subscription") }]}
      />
      {allowed ? <SubscriptionBody /> : <Alert tone="info">{t("account.noPermission")}</Alert>}
    </>
  );
}
